<script setup>
import {sprintf} from 'sprintf-js';
import {computed} from 'vue';
import {nl2br} from '@utils/nl2br';

const props = defineProps({
    page: Object,
    contact: Object,
});

const headerText = 'We are here to help!';
const text = computed(() => {
    return sprintf(
        'Let us know how we can assist you by contacting %s\n' +
        'via email at %s or by phone %s.',
        props.contact.name, props.contact.email, props.contact.phone_number
    );
});


</script>

<template>
    <div class="container py-6 lg:py-10">
        <div class="2xl:w-8/12 mx-auto">
            <h1 class="header-1 text-dark mb-4 text-center" v-text="headerText"></h1>
            <div class="text-center text-xl mb-4" v-html="nl2br(text)"></div>
            <div class="rounded-xl bg-bordeaux-1 text-white text-center p-4 font-bold">
                Note: this email is not monitored outside of standard University business hours or on weekends.
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
